import { ConvexProvider } from "convex/react";
import type { ReactNode } from "react";
import { convex } from "./convex";

export function ConvexClientProvider({ children }: { children: ReactNode }) {
	return <ConvexProvider client={convex}>{children}</ConvexProvider>;
}
